<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="3">
        </b-col>
        <b-col>
          <b-container fluid>
            <b-row class="height-75px">
              <b-col v-for="(item,index) of colorCodeList" :key="item.id" class="line-height-75px align-center" @click="changeList(index)" >
                <b-img v-bind="mainProps" :class="SelectClass(index)" :blank-color="item" rounded="circle" center alt></b-img>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="3">
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import store_saleBusinessCard from "@/vuex/store_saleBusinessCard.js";

export default {
  data() {
    return {
      selecttor: "",
      colorCodeList: [
        "#A6875C",
        "#ED4C7C",
        "#404040",
        "#3FA76F",
        "#497FDB",
        "#ED5F36",
        "#7B6FF5"
      ],
      mainProps: { blank: true, width: 25, height: 25 }
    };
  },
  created() {
    this.selecttor = this.colorCodeList[this.saleBusinessCard.colorEnum];
  },
  methods: {
    SelectClass(index) {
      if (
        this.colorCodeList[index]==this.selecttor
      ) {        
        return "choised";
      } else {        
        return "";
      }
    },

    changeList(index) {
      this.selecttor = this.colorCodeList[index];
      store_saleBusinessCard.dispatch(
        "setColorEnum",
        index.toString()
      );
    }
  },
  computed:{
    saleBusinessCard() {
      return store_saleBusinessCard.state;
    }
  }
};
</script>

<style>
.choised {
  width: 40px;
  height: 40px;
}
.line-height-75px{
   line-height:75px;
}
.height-75px{
   height:75px;
}
.align-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/SaleBusinessCardChoiseColorEnum.vue